// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-items[data-v-4ca84b08]{padding:10px 12px}.count-error[data-v-4ca84b08]{color:var(--v-error-base);font-size:12px}", ""]);
// Exports
module.exports = exports;
